import { SERVER_URL } from "@/env";
import axios from "axios";

const config = {
  toolbar: [
    "link",
    "unLink",
    "|",
    "picture",
    "|",
    "fullscreen",
    "|",
    "sourceCode",
    "|",
    "bold",
    "italic",
    "strikeThrough",
    "removeFormat",
    "|",
    "insertUnorderedList",
    "insertOrderedList",
    "indent",
    "outdent",
    "|",
    "element"
  ],

  uploadUrl: `${SERVER_URL}/api/image`
};

export function customizeEditor(vueditorInstance, $blogStore) {
  handleUploadImagesErrors(vueditorInstance, $blogStore);
  applyBreakWordsCss(vueditorInstance);
}

function handleUploadImagesErrors(vueditorInstance, $blogStore) {
  vueditorInstance.upload = async (obj, callback) => {
    try {
      let formData = new FormData();
      formData.append("image", obj.files[0]);

      const res = await axios.post(config.uploadUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      callback(res.data);
    } catch (e) {
      $blogStore.dispatch("setHttpError", e);
      // hide choose image dialog
      vueditorInstance.$store.dispatch("updatePopupDisplay");
    }
  };
}

// vueditor uses same "technique" to customize itself, ¯\_(ツ)_/¯
function applyBreakWordsCss(vueditorInstance) {
  const iframes = vueditorInstance.$el.getElementsByTagName("iframe");
  if (iframes.length > 0 && iframes[0].contentWindow) {
    iframes[0].contentWindow.document.head.insertAdjacentHTML(
      "beforeEnd", "<style>body { overflow-wrap: break-word; }</style>")
  }
}

export default config;
